import {Provider} from '@angular/core';

import {
  VerifyAuthUseCaseProvider
} from '@features/auth/presentation/providers/verify-auth/verify-auth.use-case.provider';

import {VerifyAuthFacade} from '@features/auth/presentation/facades/verify-auth/verify-auth.facade';

export const VerifyAuthFacadeProvider: Provider[] = [
  VerifyAuthUseCaseProvider,
  VerifyAuthFacade
];
